import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { contentfulToImageData } from "../../../functions";
import { Paragraph } from "../../../components/Paragraph";
export const PostAuthor = ({ image, information }) => {
    if (!information)
        return null;
    const imageData = contentfulToImageData(image);
    return (_jsxs("section", { className: "flex flex-col md:flex-row bg-white p-6 rounded-lg mt-6 ", children: [imageData && (_jsx("img", { src: imageData.imageUrl, alt: imageData.description || "Author image", className: "rounded-lg aspect-square object-cover object-top mr-4 w-full md:w-[50%]" })), _jsx("div", { className: "flex flex-col justify-start w-full md:w-[50%]", children: _jsx(Paragraph, { paragraph: information }) })] }));
};
